
import { ChatState } from "@/utils/chat-state";
import Vue from "vue";
import { UserInfo } from "../../models/dossier/user-info";
import { AuthService } from "../../services/auth-service";
import { ChatService } from "../../services/chat-service";
import { DossierService } from "../../services/dossier-service";
import { MainSocketService } from "../../services/main-socket-service";

export default Vue.extend({
	data() {
		return {
			users: [] as UserInfo[],
			online: ChatService.users as UserInfo[],
		};
	},
	props: {
		state: {
			type: Object as () => ChatState,
			required: true
		}
	},
	computed: {
		userList(): UserInfo[] {
			if (!AuthService.wfUser){
				return [];
			}
			let userID = AuthService.wfUser.ID;
			return this.users.map((user) => {
				let u = new UserInfo(user.getJSON());
				if (this.online.find(f => f.ID == u.ID)) {
					u.Online = true;
				} else {
					u.Online = false;
				}
				let c = this.state.conversationList.find(f => (f.UserID == u.ID && f.DmUserID == userID) || (f.DmUserID == u.ID && f.UserID == userID));
				if (c) {
					u.ConversationID = c.ID;

					let unread = this.state.conversationUnreads.find(f => (f.ConversationID == u.ConversationID));
					if (unread) {
						u.Unread = unread.Count;
					}
				}
				return u;
			});
		}
	},
	methods: {
		userOnline(user: UserInfo) {
			var u = new UserInfo(user);
			this.online.push(u);
		},
		userOffline(id: any) {
			this.online = this.online.filter(u => u.ID != id);
		},
		onMessageUnread(conversationID: number) {
			this.userList.forEach((u: UserInfo) => {
				if (u.ConversationID == conversationID) {
					if (!u.Unread) {
						u.Unread = 0;
					}
					u.Unread++;
				}
			});
		},
		onMessageRead(conversationID: number) {

			this.userList.map(function(u: UserInfo) {
				if (u.ConversationID == conversationID) {
					u.Unread = 0;
				}
			});
		}
	},
	async created() {
		this.users = await DossierService.getUsers();
		this.online = await ChatService.getUsers();
		for (let user of this.userList) {
			MainSocketService.on(`/chat/${user.ConversationID}/conversation/unread`, this.onMessageUnread, this);
			MainSocketService.on(`/chat/${user.ConversationID}/conversation/read`, this.onMessageRead, this);
		}
	},
	async mounted() {
		MainSocketService.on("/user-online", this.userOnline, this);
		MainSocketService.on("/user-offline", this.userOffline, this);
	},
	beforeDestroy(): void {
		MainSocketService.offAll(this);
	}
});
